<template>
	<v-btn v-bind="$attrs" v-on="$listeners" class="cta-button" depressed dark style="text-transform: none !important">
		<slot />
	</v-btn>
</template>

<script>
export default {
	name: 'CTAButton',
};
</script>

<style scoped lang="scss">
.cta-button {
	background-color: var(--primary-color) !important;
	border-color: var(--primary-color) !important;
}
</style>
